import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Tracker from "@/pages/Tracker";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AuthCallback from "@/components/AuthCallback";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { ParlayProvider } from "@/lib/parlay";
import { FavoritesProvider } from "@/lib/favorites";
import { SubscriptionsProvider } from "@/lib/subscriptions";
import ParlayBuilder from "@/components/ParlayBuilder";
import ParlayFab from "@/components/ParlayFab";

// Any route can arrive back from Emergent Auth with `#session_id=…` in the hash.
// Short-circuit to AuthCallback before anything else renders so the one-shot
// session exchange happens before the AuthProvider probes /me.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/tracker" element={<Tracker />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <FavoritesProvider>
          <SubscriptionsProvider>
            <ParlayProvider>
              <BrowserRouter>
                <AppRouter />
                <ParlayFab />
                <ParlayBuilder />
              </BrowserRouter>
            </ParlayProvider>
          </SubscriptionsProvider>
        </FavoritesProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
